/**
 * PerformAI API
 * PerformAI API documentation
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RoleDTO } from './roleDTO';


export interface ManagedUserVM {
    activated?: boolean;
    authorities?: Array<string>;
    createdBy?: string;
    createdDate?: string;
    email?: string;
    firstName?: string;
    id?: string;
    imageUrl?: string;
    langKey?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    lastName?: string;
    login: string;
    password?: string;
    role?: RoleDTO;
    roleExpiration?: string;
    sport?: string;
}

